import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function IndustriesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Industries We Serve</h1>
          <p className="text-xl md:text-2xl max-w-3xl font-light">
            Deep industry expertise across multiple sectors, delivering tailored solutions that drive measurable results.
          </p>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">Our Industry Expertise</h2>
            <div className="w-24 h-1 bg-teal-500 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              We bring specialized knowledge and proven methodologies to help businesses across diverse industries achieve their strategic objectives.
            </p>
          </div>

          <div className="space-y-16">
            {/* Technology */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src="https://www.simon-kucher.com/sites/default/files/styles/card_400_x_480/public/content-type-blog/2025-12/sector_trends_-_tmt.jpg.webp?itok=wUEDCv4J"
                    alt="Technology Industry"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full mb-4">
                  <i className="ri-computer-line text-xl"></i>
                  <span className="font-semibold">Technology</span>
                </div>
                <h3 className="text-3xl font-bold mb-4 text-gray-900">Technology Sector</h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Navigate the fast-paced technology landscape with strategic guidance on product development, market positioning, and scaling operations. We help tech companies from startups to enterprises achieve sustainable growth.
                </p>
                <ul className="space-y-3">
                  {[
                    'SaaS and software companies',
                    'IT services and consulting',
                    'Hardware and electronics',
                    'Digital transformation initiatives'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Finance */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full mb-4">
                  <i className="ri-bank-line text-xl"></i>
                  <span className="font-semibold">Finance</span>
                </div>
                <h3 className="text-3xl font-bold mb-4 text-gray-900">Financial Services</h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Partner with financial institutions to optimize operations, enhance customer experience, and navigate regulatory challenges. Our expertise spans banking, insurance, and investment management.
                </p>
                <ul className="space-y-3">
                  {[
                    'Banking and credit unions',
                    'Insurance companies',
                    'Investment and wealth management',
                    'Fintech and payment solutions'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src="https://www.simon-kucher.com/sites/default/files/styles/card_400_x_480/public/content-type-blog/2025-12/gettyimages_brothers91_2211153615_hd.jpg.webp?itok=EXFiLl8E"
                    alt="Finance Industry"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Healthcare */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src="https://www.simon-kucher.com/sites/default/files/styles/card_400_x_480/public/content-type-blog/2025-12/gettyimages_goran13_2184632666_hd.jpg.webp?itok=CdJbtK60"
                    alt="Healthcare Industry"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full mb-4">
                  <i className="ri-heart-pulse-line text-xl"></i>
                  <span className="font-semibold">Healthcare</span>
                </div>
                <h3 className="text-3xl font-bold mb-4 text-gray-900">Healthcare & Life Sciences</h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Support healthcare organizations in improving patient outcomes, operational efficiency, and financial performance. We understand the unique challenges of healthcare delivery and life sciences innovation.
                </p>
                <ul className="space-y-3">
                  {[
                    'Hospitals and healthcare systems',
                    'Medical device companies',
                    'Pharmaceutical and biotech',
                    'Healthcare technology providers'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Manufacturing */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full mb-4">
                  <i className="ri-factory-line text-xl"></i>
                  <span className="font-semibold">Manufacturing</span>
                </div>
                <h3 className="text-3xl font-bold mb-4 text-gray-900">Manufacturing & Industrial</h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Help manufacturers optimize production, improve supply chain efficiency, and adapt to Industry 4.0 technologies. Our solutions drive operational excellence and competitive advantage.
                </p>
                <ul className="space-y-3">
                  {[
                    'Discrete and process manufacturing',
                    'Automotive and aerospace',
                    'Industrial equipment and machinery',
                    'Supply chain and logistics'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src="https://www.simon-kucher.com/sites/default/files/styles/card_400_x_480/public/content-type-blog/2025-12/sector_trends_-_ind.jpg.webp?itok=td7KET0Y"
                    alt="Manufacturing Industry"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>

            {/* Professional Services */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src="https://www.simon-kucher.com/sites/default/files/styles/card_400_x_480/public/content-type-blog/2025-12/sector_trends_-_con.jpg.webp?itok=86d8yFbE"
                    alt="Professional Services"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full mb-4">
                  <i className="ri-briefcase-line text-xl"></i>
                  <span className="font-semibold">Professional Services</span>
                </div>
                <h3 className="text-3xl font-bold mb-4 text-gray-900">Professional Services</h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  Empower professional service firms to scale their practices, improve client delivery, and enhance profitability. We understand the unique dynamics of knowledge-based businesses.
                </p>
                <ul className="space-y-3">
                  {[
                    'Legal and accounting firms',
                    'Management consulting',
                    'Engineering and architecture',
                    'Marketing and creative agencies'
                  ].map((item, index) => (
                    <li key={index} className="flex items-start gap-3">
                      <i className="ri-check-line text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industry Approach */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">Our Industry Approach</h2>
            <div className="w-24 h-1 bg-teal-500 mx-auto mb-6"></div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-focus-3-line',
                title: 'Deep Specialization',
                description: 'Our consultants have extensive experience and specialized knowledge in their respective industries.'
              },
              {
                icon: 'ri-database-2-line',
                title: 'Data-Driven Insights',
                description: 'We leverage industry benchmarks and market data to inform strategic recommendations.'
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Tailored Solutions',
                description: 'Every engagement is customized to address the unique challenges and opportunities of your industry.'
              },
              {
                icon: 'ri-global-line',
                title: 'Best Practices',
                description: 'We bring proven methodologies and best practices from leading organizations worldwide.'
              },
              {
                icon: 'ri-links-line',
                title: 'Industry Networks',
                description: 'Access our extensive network of industry experts, partners, and thought leaders.'
              },
              {
                icon: 'ri-line-chart-line',
                title: 'Measurable Impact',
                description: 'We focus on delivering tangible results that drive growth and improve performance.'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
                <div className="w-14 h-14 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold mb-3 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
